import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const HIDE_FOOTER = new Set(['/play', '/practice', '/arena']);

function hideFooter(pathname: string) {
  if (HIDE_FOOTER.has(pathname)) return true;
  if (/^\/leagues\/[^/]+\/play\//.test(pathname)) return true;
  return false;
}

export function SiteFooter() {
  const { pathname } = useLocation();

  if (hideFooter(pathname)) return null;

  return (
    <footer className="site-footer">
      <nav className="site-footer-nav" aria-label="Informations légales">
        <Link to="/mentions-legales">Mentions légales</Link>
        <Link to="/cgu">CGU</Link>
        <Link to="/cgv">CGV</Link>
        <Link to="/confidentialite">Confidentialité</Link>
        <Link to="/credits">Crédits photos</Link>
      </nav>
      <p className="site-footer-copy">
        Dezoom — édité par{' '}
        <a href="https://progragames.com/" target="_blank" rel="noopener noreferrer">
          PrograGames
        </a>
      </p>
    </footer>
  );
}
